import axios from '@/libs/api.request'

export const getLawinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/lawinfo/lawinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationLawinfo = (data, meth) => {
  return axios.request({
    url: '/v1/lawinfo/lawinfo/',
    method: meth,
    data
  })
}